export enum AllTimeLeaderboardTab {
  SCORE = 'score',
  REFERRAL = 'referral',
}

export enum LeaderboardViewType {
  ALL_TIME = 'allTime',
  CAMPAIGN = 'campaign',
}

export type LeaderboardViewKey = `${LeaderboardViewType}`;

export type AllTimeLeaderboardTabId = `${AllTimeLeaderboardTab}`;
